import { useTranslation } from "react-i18next";
import { Button } from "../../atom/Button";
import Typo from "../../atom/Typo";
import styled from "styled-components";
import {
  QDialogRoot,
  QDialogPortal,
  QDialogOverlay,
  QDialogContent,
} from "../../quantum/DialogQuantum";
import zIndex from "@/src/styles/zIndex";

interface NoRegisteredSignatureAlertDialogProps {
  open: boolean;
  onOpenChange: () => void;
  onOk: () => void;
  onCancel: () => void;
}

/**
 * @description
 * - 서명이 없는경우 사용하는 AlertDialog
 */
const NoRegisteredSignatureAlertDialog = ({
  open,
  onOk,
  onOpenChange,
  onCancel,
}: NoRegisteredSignatureAlertDialogProps) => {
  const { t } = useTranslation();

  return (
    <QDialogRoot open={open} onOpenChange={onOpenChange}>
      <QDialogPortal>
        <StyledOverlay />
        <StyledDialogContent>
          <ContentContainer>
            <TitleText>
              {t("common:noRegisteredSignatureTitle")}
            </TitleText>
            <DescriptionText>
              {t("common:noRegisteredSignatureDescription")}
            </DescriptionText>
          </ContentContainer>
          <DialogFooter>
            <Button
              buttonGrade="tertiary"
              buttonColor="black"
              onClick={onCancel}
            >
              <Typo typoType="btn3m">{t("common:close")}</Typo>
            </Button>
            <Button
              onClick={onOk}
            >
              <Typo typoType="btn3m" color="white">
                {t("common:signatureRegister")}
              </Typo>
            </Button>
          </DialogFooter>
        </StyledDialogContent>
      </QDialogPortal>
    </QDialogRoot>
  );
};

export default NoRegisteredSignatureAlertDialog;

const StyledOverlay = styled(QDialogOverlay)`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${zIndex.dialog};
`;

const StyledDialogContent = styled(QDialogContent)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 16px;
  width: 305px;
  min-height: 158px;
  box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.12);
  z-index: ${zIndex.dialog};
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  flex: 1;
`;

const TitleText = styled.div`
  color: #222729;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
`;

const DescriptionText = styled.div`
  margin-top: 8px;
  color: #5e696e;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

const DialogFooter = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 24px;
  
  & > button {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    
    /* 닫기 버튼 스타일 */
    &:first-child {
      border-radius: 8px;
      background: #FFF;
      border: none;
      /* Btn Shadow/Black/Default */
      box-shadow: 0px 0px 0px 0.5px rgba(160, 164, 171, 0.20), 0px 1px 2px 0px rgba(5, 29, 57, 0.10);
      
      &:focus {
        outline: none;
      }
    }
  }
`;
